@if (donneesGen) {
  <div class="row">
    <!-- SERVICES -->
    <div class="col-10">
      <table class="table table-striped table-smaller table-not-rounded">
        <caption class="caption-sm caption-rounded">
          <div class="row">
            <div class="col-md-10">{{lgTrad.SERVACTIFS}}</div>
            <div class="col-md-2 text-right">
              @if (droitsAccess.write && hasAccessEditServices()) {
                <add-button class="pr-2 tab-btn-roundadd" (click)="openCreerService()"
                  />
              }
            </div>
          </div>
        </caption>
        <thead>
          <tr>
            <th>{{lgTrad.DEBUT}}</th>
            <th>{{lgTrad.SERV}}</th>
            <th>{{lgTrad.INFORMATIONS}}</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          @for (serv of donneesGen.SERVICES; track serv) {
            <tr>
              <ng-container>
                <td>{{serv.DDEBUT | dateFormat}}</td>
                <td>{{serv.TYPESERVICE.SERVICE}}</td>
                <td>{{serv.INFORMATIONS}}</td>
                <td>
                  <div class="btn-group w-100 justify-content-end">
                    @if (hasAccessEditServices()) {
                      @if (isAccessWrite(Constantes.CodeOption.CGESTIONSERV)) {
                        <gala-btn-edit (click)="emitService(serv)" />
                      } @else {
                        <gala-btn-search (click)="emitService(serv)" />
                      }
                    }
                  </div>
                </td>
              </ng-container>
            </tr>
          }
        </tbody>
      </table>
    </div>
    <!-- INSTALLATIONS -->
    <div class="col-10">
      <table class="table table-striped table-smaller table-not-rounded">
        <caption class="caption-sm caption-rounded">
          <div class="row">
            <div class="col-md-10">{{lgTrad.INSTALLACT}}</div>
            <div class="col-md-2 text-right">
              @if (droitsAccess.write) {
                <add-button class="pr-2 tab-btn-roundadd" (click)="emitInstallations()"
                  />
              }
            </div>
          </div>
        </caption>
        <thead>
          <tr>
            <th>{{lgTrad.INSTALLATION}}</th>
            <th>{{lgTrad.POSTES}}</th>
            <th>{{lgTrad.MARQ}}</th>
            <th>{{lgTrad.MOD}}</th>
            <th>{{lgTrad.INFORMATIONS}}</th>
          </tr>
        </thead>
        <tbody>
          @for (inst of donneesGen.INSTALLATIONS; track inst) {
            <tr>
              <ng-container>
                @if (inst.TYPEEQUIP && inst.TYPEEQUIP.IDTYPEEQUIP) {
                  <td>{{inst.EQUIP.LIB}} -
                  {{inst.TYPEEQUIP.LIB}}</td>
                }
                @if (!inst.TYPEEQUIP || !inst.TYPEEQUIP.IDTYPEEQUIP) {
                  <td>{{inst.EQUIP.LIB}}</td>
                }
                <td>{{inst.NBPOSTE}}</td>
                @if (inst.MARQUE) {
                  <td>{{inst.MARQUE.LIB}}</td>
                }
                @if (inst.MARQUE) {
                  <td>{{inst.MODELE.LIB}}</td>
                }
                <td>{{inst.INFORMATIONS}}</td>
              </ng-container>
            </tr>
          }
        </tbody>
      </table>
    </div>
    <!-- LAITERIES -->
    <div class="col-10">
      <table class="table table-striped table-smaller table-not-rounded">
        <caption class="caption-sm caption-rounded">
          <div class="row">
            <div class="col-md-10">{{lgTrad.LAITERIES}}</div>
            <div class="col-md-2 text-right">
              <search-button class="pr-2 tab-btn-roundadd" (click)="openHistoLaiteries()" />
              @if (droitsAccess.write) {
                <add-button class="pr-2 tab-btn-roundadd" (click)="openLaiteries()"
                  />
              }
            </div>
          </div>
        </caption>
        <thead>
          <tr>
            <th>{{lgTrad.NOM}}</th>
            <th>{{lgTrad.INFORMATIONS}}</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          @for (lait of donneesGen.LAITERIES; track lait) {
            <tr>
              <ng-container>
                <td>{{lait.ORGANISME.NOM}}</td>
                <td>{{lait.INFORMATIONS}}</td>
                <td>
                  <div class="btn-group w-100 justify-content-end">
                    @if (droitsAccess.write) {
                      <gala-btn-edit (click)="updateLaiterie(lait)" />
                    } @else {
                      <gala-btn-search (click)="updateLaiterie(lait)" />
                    }
                  </div>
                </td>
              </ng-container>
            </tr>
          }
        </tbody>
      </table>
    </div>
    <!-- ENGAGEMENTS QUALITE -->
    <div class="col-5">
      <table class="table table-striped table-smaller table-not-rounded">
        <caption class="caption-sm caption-rounded">
          <div class="row">
            <div class="col-md-9">{{lgTrad.ENGAGEMENTS}}</div>
            <div class="col-md-3 text-right">
              <search-button class="pr-2 tab-btn-roundadd" (click)="openHistoEngagements()" />
              @if (droitsAccess.write) {
                <add-button class="pr-2 tab-btn-roundadd" (click)="openEngagements()"
                  />
              }
            </div>
          </div>
        </caption>
        <thead>
          <tr>
            <th>{{lgTrad.NOM}}</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          @for (qlt of donneesGen.QUALITES; track qlt) {
            <tr>
              <ng-container>
                <td>{{qlt.RFQUALITE.QUALITE}}</td>
                <td>
                  <div class="btn-group w-100 justify-content-end">
                    @if (droitsAccess.write) {
                      <gala-btn-delete
                        (click)="deleteEngagement(qlt)" />
                    }
                  </div>
                </td>
              </ng-container>
            </tr>
          }
        </tbody>
      </table>
    </div>
  </div>
}
